import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = {
  key: 2,
  class: "new-list-flag"
}

import { ref, reactive, computed, onMounted, toRaw } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { Modal as AModal } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import Modal from '@/hooks/modalType'
import ImportBtn from '@/components/ImportBtn'
import ClueAssign from '../components/ClueAssign.vue'
import BecomeValid from './components/BecomeValid.vue'
import BecomeInvalid from './components/BecomeInvalid.vue'
import ExportDetails from './components/ExportDetails.vue'
import ClueMarge from './components/ClueMarge.vue'
import CustomerArea from '@/components/CustomerArea'
import EditorTableText from '@/components/Editor/src/tableText.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import { listByParamCodes, adminArea, cancelToFav, addToFav } from '@/api/common'
import {
  customerUnfollowDayTypeEnum,
  genderEnum,
  linkRoleTypeEnum,
  flagEnum, favoriteStatus
} from '@/views/gucangSales/commonEnum/dataConfig'
import { clueStatusEnum, clueTypeEnum } from '../dataConfig'
import { salesClueList, salesClueRefund, salesClueDelete, salesClueDetail } from '@/api/gucangSales/clueManage'
import type { ParamCodeItem } from '@/typings/common'
import type { SalesClueParams, SalesClueListItem } from '@/typings/api/clueManage'
import FavoriteIcon from '@/components/FavoriteIcon/index.vue'


const __default__ = { name: 'DcCosFbuSalesClue' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const route = useRoute()

// 线索类型枚举列表
const clueTypeEnumComputed = computed(() => clueTypeEnum.filter((item) => item.value !== 0))
const statusEnum = clueStatusEnum.map((item) => ({
  name: item.label,
  value: item.value,
  color: item.color
}))
// 业务参数
const paramCodeData = ref<{
  fbu_source_channel: ParamCodeItem[]
  fbu_industrial_belt: ParamCodeItem[]
  fbu_customer_category: ParamCodeItem[]
}>({
  fbu_source_channel: [], // 客户来源
  fbu_industrial_belt: [], // 产业带
  fbu_customer_category: [] // 客户类别
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: ['fbu_source_channel', 'fbu_industrial_belt', 'fbu_customer_category']
  }).then((res) => {
    paramCodeData.value = res.data
  })
}
onMounted(() => getByParamCodes())
// 获取办公地省市区数据
const customerAreaEnum = ref<any[]>([])
const getAdminArea = () => {
  const params = { appId: 'cos_fbu' }
  adminArea(params).then((res) => {
    customerAreaEnum.value = res.data
  })
}
// 获取详情联系人信息
const showMask = (record: SalesClueListItem, callBack: (res: any) => void) => {
  salesClueDetail({ clueId: record.clueId }).then((res) => {
    const { contact } = res.data
    callBack(contact)
  })
}
onMounted(() => {
  getAdminArea()
})

const tableRef = ref()
const queryForm = reactive<SalesClueParams>({
  sortCollection: 1,
  clueStatus: 3,
  contact: { type: 1 }
})
const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    fixed: 'left',
    width: 200
  },
  {
    title: '线索ID',
    dataIndex: 'clueId',
    width: 200
  },
  {
    title: '线索来源',
    dataIndex: 'channel',
    width: 150
  },
  {
    title: '线索类型',
    dataIndex: 'clueType',
    dicData: clueTypeEnum
  },
  {
    title: '线索状态',
    dataIndex: 'clueStatus'
  },
  {
    title: '客户区域',
    dataIndex: 'customerRegion'
  },
  {
    title: '客户负责人',
    dataIndex: 'followerName'
  },
  {
    title: '前负责人',
    dataIndex: 'beforeFollowerName'
  },
  {
    title: '未跟进天数',
    dataIndex: 'notFollowDayNum'
  },
  {
    title: '客户办公地',
    dataIndex: 'customerOffice'
  },
  {
    title: '最新跟进情况',
    dataIndex: 'followDesc'
  },
  {
    title: '是否产业带',
    dataIndex: 'industrialBeltFlag',
    dicData: flagEnum
  },
  {
    title: '产业带',
    dataIndex: 'industrialBelt',
    dicData: paramCodeData.value.fbu_industrial_belt
  },
  {
    title: '产业带名称',
    dataIndex: 'industrialBeltName'
  },
  { title: '客户类别', dataIndex: 'customerCategory', dicData: paramCodeData.value.fbu_customer_category },
  {
    title: '联系人姓名',
    dataIndex: ['contact', 'name'],
    cosType: 'mask'
  },
  {
    title: '手机号',
    dataIndex: ['contact', 'mobile'],
    cosType: 'mask'
  },
  {
    title: '微信号',
    dataIndex: ['contact', 'wechat'],
    cosType: 'mask'
  },
  {
    title: '邮箱',
    dataIndex: ['contact', 'email'],
    cosType: 'mask'
  },
  {
    title: 'QQ号',
    dataIndex: ['contact', 'qq'],
    cosType: 'mask'
  },
  {
    title: '固定电话',
    dataIndex: ['contact', 'tel'],
    cosType: 'mask'
  },
  {
    title: '性别',
    dataIndex: ['contact', 'sex'],
    dicData: genderEnum
  },
  {
    title: '角色',
    dataIndex: ['contact', 'jobRole'],
    dicData: linkRoleTypeEnum
  },
  {
    title: '部门职务',
    dataIndex: ['contact', 'jobDuty']
  },
  {
    title: '资料完善度',
    dataIndex: 'dataIntegrity'
  },
  {
    title: '联系时间',
    dataIndex: ['contactStartTime', 'contactEndTime'],
    cosType: 'timeRange'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    width: 190
  },
  {
    title: '首次领取时间',
    dataIndex: 'firstReceiveTime',
    width: 190
  },
  {
    title: '最后一次领取时间',
    dataIndex: 'lastReceiveTime',
    width: 190
  },
  {
    title: '转潜在客户时间',
    dataIndex: 'stageChangeTime',
    width: 190
  },
  {
    title: '备注',
    dataIndex: 'remark'
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: 220,
    fixed: 'right'
  }
])
const getList = (queryForm: SalesClueParams, callBack: (res: any) => void) => {
  salesClueList(queryForm).then((res) => {
    callBack(res)
  })
}
const handleQueryChange = (type: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
const deleteRefresh = (num: number) => {
  const params = toRaw(selectedData.value)
  params.splice(0, num)
  tableRef.value?.delFetch(params, 'clueId')
}

const selectedData = ref<SalesClueListItem[]>([])
const onSelectRowsChange = (selectedRowKeys: string[], selectedRows: SalesClueListItem[]) => {
  selectedData.value = selectedRows
}

// 退回线索
const handleSendBack = () => {
  if (selectedData.value.length === 0) return message.warning('请选择要退回的线索')
  const params = {
    clueIdList: selectedData.value.map((item: SalesClueListItem) => item.clueId)
  }
  salesClueRefund(params).then(() => {
    message.success('退回成功')
    handleQueryChange('fetch')
  })
}

// 申请转有效线索
const becomeValidRef = ref()
const handleBecomeValid = () => {
  if (!selectedData.value.length) return message.warning('请先勾选一条无效线索')
  const hasValid = selectedData.value.some((item: SalesClueListItem) => item.clueType !== 3)
  if (hasValid) return message.warning('仅能勾选无效线索数据提交')
  becomeValidRef.value?.init(toRaw(selectedData.value))
}

// 置为无效线索
const becomeInvalidRef = ref()
const handleBecomeInvalid = (row?: SalesClueListItem) => {
  if (!row && !selectedData.value?.length) return message.warning('请先勾选需要置为无效的线索')
  const paramsRow = row ? [row] : toRaw(selectedData.value)
  becomeInvalidRef.value?.init(paramsRow)
}

// 新增编辑函数
const triggerAddOrEdit = (clueId?: string, isPerfect?: string) => {
  if (clueId) {
    router.push({
      path: '/fbu/salesClue/edit',
      query: {
        clueId,
        isPerfect
      }
    })
  } else {
    router.push('/fbu/salesClue/add')
  }
}
// 跳转写跟进页面
const handleWriteFollowUp = (clueId: string) => {
  router.push({
    path: '/fbu/followUpRecord/add',
    query: {
      followRefId: clueId,
      returnPath: route.fullPath
    }
  })
}
// 分配客户负责人
const clueAssignRef = ref()
const handleAssignPerson = () => {
  if (!selectedData.value.length) return message.warning('请选择需要分配的线索')
  clueAssignRef.value?.init(toRaw(selectedData.value))
}

// 合并线索
const clueMargeRef = ref()
const handleClueMarge = () => {
  if (selectedData.value.length < 2) return message.warning('请选择2个或以上线索合并')
  clueMargeRef.value?.init(toRaw(selectedData.value))
}

const exportDetailsRef = ref()
const handleExportDetails = () => {
  exportDetailsRef.value?.init()
}

// 转潜在客户
const handleTurnPotential = (row?: SalesClueListItem) => {
  if (!row) return
  if (row.clueType === 3) return message.warning('无效线索不能转潜在客户')
  if (row.dataIntegrity !== 100) {
    AModal.confirm({
      title: '请将客户资料补充完整！',
      content: '将客户信息补充完整，才能转潜在！',
      okText: '完善资料',
      onOk() {
        router.push({
          path: '/fbu/salesClue/edit',
          query: {
            clueId: row.clueId,
            isPerfect: 'required'
          }
        })
      },
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onCancel() {
      }
    })
  } else {
    router.push({
      path: '/fbu/business/add',
      query: {
        saleChanceRefId: row.clueId,
        isFromPotentialCustomer: 1,
        returnPath: route.fullPath
      }
    })
  }
}
const handleDelete = (row?: SalesClueListItem) => {
  if (!row && !selectedData.value?.length) {
    return message.error('请选择要删除的数据')
  }
  const clueIdList: any[] = []
  const customerName = []
  if (row) {
    clueIdList.push(row.clueId)
    customerName.push(row.customerName)
  } else {
    selectedData.value?.forEach((item) => {
      clueIdList.push(item.clueId)
      customerName.push(item.customerName)
    })
  }
  Modal.delete({
    content: `删除【${customerName.join(
      ','
    )}】，会同步删除该线索相关的商机、访客计划、跟进记录，且删除操作无法恢复，请谨慎操作。`,
    onOk() {
      salesClueDelete({ clueIdList }).then(() => {
        message.success('删除线索成功')
        deleteRefresh(0)
      })
    }
  })
}
// 收藏
const addFavorite = (row: SalesClueListItem, index:number) => {
  addToFav({
    appId: 'cos_fbu',
    cosId: row.clueId,
    stage: 1
  }).then((res) => {
    if (res.code === 200) {
      row.collectionId = row.clueId
      tableRef.value?.notifyItem(index, row)
    }
  })
}
// 收藏
const cancelFavorite = (row: SalesClueListItem, index:number) => {
  cancelToFav({
    appId: 'cos_fbu',
    cosId: row.clueId,
    stage: 1
  }).then((res) => {
    if (res.code === 200) {
      row.collectionId = null
      row.collectionTime = null
      tableRef.value?.notifyItem(index, row)
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_CosRangePicker = _resolveComponent("CosRangePicker")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_CosCascader = _resolveComponent("CosCascader")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dc_status = _resolveComponent("dc-status")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_MoreButton = _resolveComponent("MoreButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dc_layout_main, { "is-breadcrumb": true }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_cos_table, {
              serial: "",
              rowKey: "clueId",
              "row-selection": { onChange: onSelectRowsChange },
              columns: columns.value,
              search: queryForm,
              "onUpdate:search": _cache[27] || (_cache[27] = ($event: any) => ((queryForm) = $event)),
              onFetch: getList,
              onMask: showMask,
              ref_key: "tableRef",
              ref: tableRef,
              tableId: "DcCosFbuSalesClue"
            }, {
              search: _withCtx(() => [
                _createVNode(_component_a_form, { model: queryForm }, {
                  default: _withCtx(() => [
                    _createVNode(_component_dc_form_item, { label: "线索状态" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: queryForm.clueStatus,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.clueStatus) = $event)),
                          optionType: "button",
                          options: _unref(clueStatusEnum),
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (handleQueryChange('search')))
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "线索类型" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: queryForm.clueTypeList,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.clueTypeList) = $event)),
                          options: clueTypeEnumComputed.value,
                          placeholder: "请选择",
                          allowClear: "",
                          mode: "multiple",
                          "max-tag-count": "responsive",
                          "show-arrow": ""
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "排序" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: queryForm.sortCollection,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.sortCollection) = $event)),
                          options: _unref(favoriteStatus),
                          placeholder: "请选择",
                          allowClear: ""
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "未跟进天数" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: queryForm.notFollowDayNumType,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.notFollowDayNumType) = $event)),
                          options: _unref(customerUnfollowDayTypeEnum),
                          placeholder: "请选择",
                          allowClear: ""
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "创建时间" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosRangePicker, {
                          startTime: queryForm.startCreateTime,
                          "onUpdate:startTime": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.startCreateTime) = $event)),
                          endTime: queryForm.endCreateTime,
                          "onUpdate:endTime": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.endCreateTime) = $event))
                        }, null, 8, ["startTime", "endTime"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "客户名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: queryForm.customerName,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.customerName) = $event)),
                          maxlength: 100,
                          allowClear: "",
                          placeholder: "请输入"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "联系方式" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_group, { compact: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: queryForm.contact.type,
                              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.contact.type) = $event)),
                              style: {"width":"33%"},
                              placeholder: "请选择"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("手机号")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 2 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("固定电话")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 3 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("邮箱")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 4 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("微信号")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 5 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("qq")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"]),
                            _createVNode(_component_a_input, {
                              value: queryForm.contact.keyword,
                              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.contact.keyword) = $event)),
                              maxlength: 100,
                              style: {"width":"67%"},
                              placeholder: "请输入",
                              allowClear: ""
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "客户负责人" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UserSelect, {
                          value: queryForm.follower,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.follower) = $event)),
                          placeholder: "请选择",
                          allowClear: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "线索ID" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: queryForm.clueId,
                          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((queryForm.clueId) = $event)),
                          maxlength: 500,
                          allowClear: "",
                          placeholder: "请输入"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "领取时间" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosRangePicker, {
                          startTime: queryForm.startReceiveTime,
                          "onUpdate:startTime": _cache[12] || (_cache[12] = ($event: any) => ((queryForm.startReceiveTime) = $event)),
                          endTime: queryForm.endReceiveTime,
                          "onUpdate:endTime": _cache[13] || (_cache[13] = ($event: any) => ((queryForm.endReceiveTime) = $event))
                        }, null, 8, ["startTime", "endTime"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "来源渠道" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_group, { compact: "" }, {
                          default: _withCtx(() => [
                            _createVNode(ParamCodeCascader, {
                              type: "search",
                              ids: queryForm.channelList,
                              "onUpdate:ids": _cache[14] || (_cache[14] = ($event: any) => ((queryForm.channelList) = $event)),
                              appId: "cos_fbu",
                              paramCode: "fbu_source_channel",
                              style: {"width":"33%"}
                            }, null, 8, ["ids"]),
                            _createVNode(_component_a_input, {
                              value: queryForm.channelExplain,
                              "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((queryForm.channelExplain) = $event)),
                              maxlength: 100,
                              style: {"width":"67%"},
                              placeholder: "请输入",
                              allowClear: ""
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "客户区域" }, {
                      default: _withCtx(() => [
                        _createVNode(CustomerAreaCascader, {
                          type: "search",
                          appId: "cos_fbu",
                          ids: queryForm.customerRegionList,
                          "onUpdate:ids": _cache[16] || (_cache[16] = ($event: any) => ((queryForm.customerRegionList) = $event))
                        }, null, 8, ["ids"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "客户办公地" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosCascader, {
                          value: queryForm.customerOffice,
                          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((queryForm.customerOffice) = $event)),
                          options: customerAreaEnum.value,
                          fieldNames: { label: 'name', value: 'id', children: 'children' },
                          placeholder: "请选择",
                          "change-on-select": "",
                          allowClear: ""
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              button: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  type: "primary",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (triggerAddOrEdit()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'fbu_clue_add_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (handleAssignPerson()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("分配负责人")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'fbu_clue_person_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_unref(ImportBtn), {
                  action: "/fbu/api/clue/import",
                  templateUrl: "/fbu/api/clue/template/download",
                  onSuccess: _cache[20] || (_cache[20] = ($event: any) => (handleQueryChange('search')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("导入 ")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'fbu_clue_import_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                  appId: "cos_fbu",
                  taskType: "201",
                  search: queryForm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("导出 ")
                  ]),
                  _: 1
                }, 8, ["search"])), [
                  [_directive_permission, 'fbu_clue_export_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (handleClueMarge()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("合并")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'fbu_clue_merge_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (handleSendBack()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("退回")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'fbu_clue_back_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (handleBecomeValid()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("申请转有效")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'fbu_clue_valid_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (handleBecomeInvalid()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("置为无效")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'fbu_clue_invalid_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  danger: "",
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (handleDelete()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'fbu_clue_del_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  onClick: _cache[26] || (_cache[26] = ($event: any) => (handleExportDetails()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("导出明细")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'fbu_clue_export_details_btn']
                ])
              ]),
              bodyCell: _withCtx(({ column, record, text, index}) => [
                (column.dataIndex === 'customerName')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      (record.collectionId===null)
                        ? (_openBlock(), _createBlock(FavoriteIcon, {
                            key: 0,
                            type: "add",
                            onClick: ($event: any) => (addFavorite(record,index))
                          }, null, 8, ["onClick"]))
                        : (_openBlock(), _createBlock(FavoriteIcon, {
                            key: 1,
                            type: "cancel",
                            onClick: ($event: any) => (cancelFavorite(record,index))
                          }, null, 8, ["onClick"])),
                      (record.clueStatus !== 8 && record.hasFollow === false)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "New"))
                        : _createCommentVNode("", true),
                      _createVNode(_component_router_link, {
                        class: "ant-table-cell-ellipsis",
                        to: `/fbu/salesClue/view?clueId=${record.clueId}`,
                        title: text
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(text || '--'), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "title"])
                    ]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'channel')
                  ? (_openBlock(), _createBlock(ChannelText, {
                      key: 1,
                      appId: "cos_fbu",
                      paramCode: "fbu_source_channel",
                      value: text,
                      desc: record.channelExplain
                    }, null, 8, ["value", "desc"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'customerRegion')
                  ? (_openBlock(), _createBlock(CustomerAreaCascaderText, {
                      key: 2,
                      appId: "cos_fbu",
                      value: text
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'clueStatus')
                  ? (_openBlock(), _createBlock(_component_dc_status, {
                      key: 3,
                      enums: _unref(statusEnum),
                      value: text
                    }, null, 8, ["enums", "value"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'customerOffice')
                  ? (_openBlock(), _createBlock(_unref(CustomerArea), {
                      key: 4,
                      type: "text",
                      value: text
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'followDesc')
                  ? (_openBlock(), _createBlock(EditorTableText, {
                      key: 5,
                      value: text
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'dataIntegrity')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                      _createTextVNode(_toDisplayString(`${text || 0}%`), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'action')
                  ? (_openBlock(), _createBlock(_component_MoreButton, { key: 7 }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                          type: "link",
                          workCode: record.follower,
                          disabled: record.clueStatus === 8,
                          onClick: ($event: any) => (triggerAddOrEdit(record.clueId, 'required'))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("完善资料 ")
                          ]),
                          _: 2
                        }, 1032, ["workCode", "disabled", "onClick"])), [
                          [_directive_permission, 'fbu_clue_complete_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          disabled: record.clueStatus === 8,
                          onClick: ($event: any) => (handleWriteFollowUp(record.clueId))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("写跟进 ")
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])), [
                          [_directive_permission, 'fbu_clue_write_follow_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                          type: "link",
                          disabled: record.clueStatus === 8,
                          onClick: ($event: any) => (triggerAddOrEdit(record.clueId))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("编辑 ")
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])), [
                          [_directive_permission, 'fbu_clue_edit_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                          type: "link",
                          workCode: record.follower,
                          disabled: record.clueStatus === 8,
                          onClick: ($event: any) => (handleTurnPotential(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("转为潜在客户 ")
                          ]),
                          _: 2
                        }, 1032, ["workCode", "disabled", "onClick"])), [
                          [_directive_permission, 'fbu_clue_potential_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                          type: "link",
                          workCode: record.follower,
                          disabled: record.clueStatus === 8,
                          onClick: ($event: any) => (handleBecomeInvalid(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("置为无效 ")
                          ]),
                          _: 2
                        }, 1032, ["workCode", "disabled", "onClick"])), [
                          [_directive_permission, 'fbu_clue_invalid_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          disabled: record.clueStatus === 8,
                          onClick: ($event: any) => (handleDelete(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("删除 ")
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])), [
                          [_directive_permission, 'fbu_clue_del_btn']
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["row-selection", "columns", "search"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(BecomeValid, {
      ref_key: "becomeValidRef",
      ref: becomeValidRef,
      onFetch: _cache[28] || (_cache[28] = ($event: any) => (handleQueryChange('fetch')))
    }, null, 512),
    _createVNode(ClueAssign, {
      ref_key: "clueAssignRef",
      ref: clueAssignRef,
      onFetch: _cache[29] || (_cache[29] = ($event: any) => (handleQueryChange('fetch')))
    }, null, 512),
    _createVNode(ClueMarge, {
      ref_key: "clueMargeRef",
      ref: clueMargeRef,
      onFetch: _cache[30] || (_cache[30] = ($event: any) => (deleteRefresh(1)))
    }, null, 512),
    _createVNode(BecomeInvalid, {
      ref_key: "becomeInvalidRef",
      ref: becomeInvalidRef,
      onFetch: _cache[31] || (_cache[31] = ($event: any) => (handleQueryChange('fetch')))
    }, null, 512),
    _createVNode(ExportDetails, {
      ref_key: "exportDetailsRef",
      ref: exportDetailsRef,
      appId: "cos_fbu",
      search: queryForm,
      taskTypeEnum: [
  { value: 214, label: '签到地址' },
  { value: 218, label: '在售平台' },
  { value: 222, label: '需求海外仓' }
]
    }, null, 8, ["search"])
  ], 64))
}
}

})